import axiosClient from './axiosClient'

const accountingdocumentApi = {
  //   findById: (id, jwtToken) => {
  //     let url = `/accounting-documents/findById?invoiceId=${id}`
  //     if (jwtToken) {
  //       url += `&jwtToken=${jwtToken}`
  //     }
  //     return axiosClient.get(url)
  //   },
  exportByLookupCode: (lookUpCode, typeFile) => {
    const url = `/accounting-documents/export-by-lookup-code?lookUpCode=${lookUpCode}&typeFile=${typeFile}`
    return axiosClient.get(url)
  },
}

export default accountingdocumentApi
